export enum QuestionDisplayType {
    Vertical = 'VERTICAL',
    Horizontal = 'HORIZONTAL',
}
